import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { useProjectListActions, useProjectListState } from '../../../shared/hooks/useApi/useProjectList';
import { IndexOrderData, ProjectElementDataWithCarousel, ProjectElementDataWithFormation } from '../../../shared/dto/EntityRepository';
import { CareerType, ModalType, TextBlockType } from '../../../shared/enum/EnumRepository';
import { richTextToPlainText } from '../../../shared/richText/document';
import { useProjectInfoActions, useProjectInfoState } from '../../../shared/hooks/useApi/useProjectInfo';
import { useProjectElementActions, useProjectElementState } from '../../../shared/hooks/useApi/useProjectElement';
import { useProjectElementListStore } from '../../../shared/store/projectElementStore';
import { ProjectElementType } from '../../../shared/enum/EnumRepository';
import { useCareer } from '../../../shared/hooks/useApi/useCareer';
import { useTextViewStore } from '../../../shared/store/TextViewStore';
import { useWorkViewStore } from '../../../shared/store/WorkViewStore';
import { useTextBlock } from '../../../shared/hooks/useApi/useTextBlock';
import { useWorkDetailActions } from '../../../shared/hooks/useApi/useWorkDetail';
import { ReorderReq, UpdateReorderListReq } from '../../../shared/dto/ReqDtoRepository';
import { useProjectDetailState } from '../../../shared/hooks/useApi/useProjectDetail';
import {
  useCanShowProjectDetail,
  useCanShowProjectElementList,
  useCanShowProjectInfoList,
  useCanShowProjectList,
} from '../../../shared/hooks/useProjectVisibility';
import { useCanShowCareerList } from '../../../shared/hooks/useCareerVisibility';
import { useCanShowGroupMemberList } from '../../../shared/hooks/useGroupMemberVisibility';
import belowIcon from '../../../asset/icon/below.png';
import { resolveCareerSections } from '../../about/CareerData';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getCareerTypeTitle, getPageMessage } from '../../../shared/constants/pageMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import IndexCardMobile from './IndexCardMobile';
import pdfIcon from '../../../asset/icon/pdf.png';
import { getFormationTypeLabel, resolveFormationSlotImage } from '../../../shared/util/formationUtils';
import { formatCarouselItemInfo, getFilledCarouselItems, resolveCarouselSlotImage } from '../../../shared/util/carouselUtils';
import { getProjectInfoDisplayName, getProjectInfoDisplayText } from '../../../shared/util/projectInfo';
import { useGroupMember } from '../../../shared/hooks/useApi/useGroupMember';
import {
  useAboutPageSettingActions,
  useAboutPageSettingState,
} from '../../../shared/hooks/useApi/useAboutPageSetting';
import { useCanShowAboutPageSetting } from '../../../shared/hooks/useAboutPageSettingVisibility';
import { mergeActiveCareerSectionOrder } from '../../../shared/util/careerSectionOrder';
import { getTextBlockLinkCaption } from '../../../shared/util/textBlockLinkCaption';
import { useLanguageStore } from '../../../shared/store/languageStore';


// Auto-scroll configuration
const AUTO_SCROLL_SPEED = 8; // 스크롤 속도 (픽셀 단위, 값이 클수록 빠름)
const DRAG_DELAY = 200; // 드래그 시작 지연 시간 (ms)

const IndexingMobile: React.FC = () => {
  const { standardModal, clearModal } = useModalStore();
  const { projects } = useProjectListState();
  const { reorderProject } = useProjectListActions();
  const { project } = useProjectDetailState();
  const canShowProjectDetail = useCanShowProjectDetail();
  const canShowInfoList = useCanShowProjectInfoList();
  const canShowElementList = useCanShowProjectElementList();
  const canShowProjectList = useCanShowProjectList();
  const canShowCareerList = useCanShowCareerList();
  const canShowGroupMemberList = useCanShowGroupMemberList();
  const { projectInfoList } = useProjectInfoState();
  const { reorderProjectInfo } = useProjectInfoActions();
  const { projectElementList } = useProjectElementState();
  const { reorderProjectElement } = useProjectElementActions();
  const reorderCarouselItems = useProjectElementListStore((s) => s.reorderCarouselItems);
  const { careerList, reorderCareer } = useCareer();
  const { aboutPageSetting } = useAboutPageSettingState();
  const { updateCareerSectionOrder } = useAboutPageSettingActions();
  const canShowAboutPageSetting = useCanShowAboutPageSetting();
  const { reorderTextBlock } = useTextBlock();
  const { reorderWorkDetail } = useWorkDetailActions();
  const { activeText, activeTextBlockList } = useTextViewStore();
  const activeWork = useWorkViewStore((s) => s.activeWork);
  const activeWorkDetailList = useWorkViewStore((s) => s.activeWorkDetailList);
  const language = useLanguageStore((s) => s.language);
  const { groupMemberList, reorderGroupMembers } = useGroupMember();
  const [orderedDataList, setOrderedDataList] = useState<IndexOrderData[]>([]);
  const [grabbedData, setGrabbedData] = useState<IndexOrderData | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const touchStartY = useRef<number>(0);
  const cardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const contentContainerRef = useRef<HTMLDivElement>(null);
  const autoScrollIntervalRef = useRef<number | null>(null);
  const dragStartTimer = useRef<NodeJS.Timeout | null>(null);
  const pendingDragData = useRef<IndexOrderData | null>(null);

  useEffect(() => {
    if (!standardModal) return;
    if (standardModal.modalType !== ModalType.INDEXING) return;
    createOrderedContent();
    cardRefs.current = [];
  }, [standardModal, language]);

  useEffect(() => {
    if (!grabbedData) {
      stopAutoScroll();
      setIsDragging(false);
    }
    
    return () => {
      stopAutoScroll();
    };
  }, [grabbedData]);

  useEffect(() => {
    return () => {
      // 컴포넌트 언마운트 시 타이머 정리
      if (dragStartTimer.current) {
        clearTimeout(dragStartTimer.current);
        dragStartTimer.current = null;
      }
    };
  }, []);

  const createOrderedContent = () => {
    switch (standardModal?.title) {
      case "Project":
        const orderedProjects = projects.map((project, index) => (
          {
            index,
            id: project.id,
            mainText: project.title,
            subText: project.isPublic ? "Public" : "Private"
          }
        ));
        setOrderedDataList(orderedProjects);
        break;
      case "Info":
        const orderedInfos = projectInfoList.map((info, index) => (
          {
            index,
            id: info.id,
            mainText: getProjectInfoDisplayName(info.customName),
            subText: getProjectInfoDisplayText(info.customValues)
          }
        ));
        setOrderedDataList(orderedInfos);
        break;
      case "Element":
        const orderedElements = projectElementList.map((element, index) => {
          switch (element.projectElementType) {
            case ProjectElementType.WORK: {
              return {
                index,
                id: element.id,
                mainText: element.work.title,
                subText: "Work",
                originUrl: element.work.uploadFile?.originUrl
              };
            }
            case ProjectElementType.DETAIL:
              return {
                index,
                id: element.id,
                mainText: element.workDetail.description,
                subText: "Detail Cut",
                originUrl: element.workDetail.uploadFile?.originUrl
              };
            case ProjectElementType.TEXTBOX:
              return {
                index,
                id: element.id,
                mainText: richTextToPlainText(element.textBox.content),
                subText: "Text Box"
              };
            case ProjectElementType.DOCUMENT:
              return {
                index,
                id: element.id,
                mainText: element.document.description,
                subText: "Visual Aid",
                originUrl: element.document.uploadFile?.originUrl
              };
            case ProjectElementType.PDF:
              return {
                index,
                id: element.id,
                mainText: element.pdfAsset.description || "PDF",
                subText: "PDF",
                originUrl: pdfIcon
              };
            case ProjectElementType.TEXT:
              return {
                index,
                id: element.id,
                mainText: element.text.title,
                subText: "Text"
              };
            case ProjectElementType.DIVIDER:
              return {
                index,
                id: element.id,
                mainText: "Divider",
                subText: ""
              };
            case ProjectElementType.FORMATION: {
              const formationElement = element as ProjectElementDataWithFormation;
              const firstItem = formationElement.formation.items[0];
              const resolvedImage = firstItem ? resolveFormationSlotImage(firstItem) : null;
              return {
                index,
                id: element.id,
                mainText: getFormationTypeLabel(formationElement.formation.formationType),
                subText: "Formation",
                originUrl: resolvedImage?.originUrl,
              };
            }
            case ProjectElementType.CAROUSEL: {
              const carouselElement = element as ProjectElementDataWithCarousel;
              const firstItem = getFilledCarouselItems(carouselElement.carousel.items)[0];
              const resolvedImage = firstItem ? resolveCarouselSlotImage(firstItem) : null;
              return {
                index,
                id: element.id,
                mainText: resolvedImage?.alt || 'Carousel',
                subText: 'Carousel',
                originUrl: resolvedImage?.originUrl,
              };
            }
            default:
              return null;
          }
        }).filter(item => item !== null) as IndexOrderData[];

        setOrderedDataList(orderedElements);
        break;
      case "Carousel": {
        const carouselElement = projectElementList.find(
          (element) => element.id === standardModal.value
            && element.projectElementType === ProjectElementType.CAROUSEL,
        );
        const orderedSlides = carouselElement?.projectElementType === ProjectElementType.CAROUSEL
          ? getFilledCarouselItems(carouselElement.carousel.items).map((item, index) => {
            const image = resolveCarouselSlotImage(item);
            return {
              index,
              id: String(item.id),
              mainText: formatCarouselItemInfo(item) || image?.alt || `Slide ${index + 1}`,
              subText: 'Carousel',
              originUrl: image?.originUrl,
            };
          })
          : [];
        setOrderedDataList(orderedSlides);
        break;
      }
        case "Text":
          const orderedTexts = activeTextBlockList.map((tb, index) => {
            switch (tb.type) {
              case TextBlockType.IMAGE:
                return {
                  index,
                  id: tb.id,
                  mainText: tb.caption,
                  subText: tb.type,
                  originUrl: tb.uploadFile?.originUrl
                };
              case TextBlockType.LINK:
                return {
                  index,
                  id: tb.id,
                  mainText: getTextBlockLinkCaption(tb),
                  subText: tb.type,
                };
              default:
                return {
                  index,
                  id: tb.id,
                  mainText: richTextToPlainText(tb.textContent),
                  subText: tb.type,
                };
            }
          });
          setOrderedDataList(orderedTexts);
          break;
      case "Detail Cut":
        const orderedDetails = activeWorkDetailList.map((wd, index) => (
          {
            index,
            id: wd.id,
            mainText: wd.description || '(No description)',
            subText: 'Detail Cut',
            originUrl: wd.uploadFile?.originUrl
          }
        ));
        setOrderedDataList(orderedDetails);
        break;
      case "Career":
        const filteredCareers = careerList.filter((each) => each.careerType === standardModal.value);
        const orderedCareers = filteredCareers.map((career, index) => (
          {
            index,
            id: career.id,
            mainText: career.content,
            subText: career.startYear
          }
        ));
        setOrderedDataList(orderedCareers);
        break;
      case "Career Section":
        const activeCareerTypes = new Set(
          careerList.map((career) => career.careerType),
        );
        const orderedCareerSections = resolveCareerSections(
          aboutPageSetting?.careerSectionOrder,
        )
          .filter((section) => activeCareerTypes.has(section.type))
          .map((section, index) => ({
            index,
            id: section.type,
            mainText: getCareerTypeTitle(section.type, language),
            subText: '',
          }));
        setOrderedDataList(orderedCareerSections);
        break;
      case "Group Member":
        const orderedGroupMembers = groupMemberList.map((member, index) => ({
          index,
          id: member.id,
          mainText: member.name,
          subText: member.role,
        }));
        setOrderedDataList(orderedGroupMembers);
        break;
    }
  };

  const stopAutoScroll = () => {
    if (autoScrollIntervalRef.current !== null) {
      cancelAnimationFrame(autoScrollIntervalRef.current);
      autoScrollIntervalRef.current = null;
    }
  };

  const startAutoScroll = (direction: 'up' | 'down') => {
    stopAutoScroll();
    
    const scroll = () => {
      if (!contentContainerRef.current) return;
      
      const scrollAmount = direction === 'up' ? -AUTO_SCROLL_SPEED : AUTO_SCROLL_SPEED;
      contentContainerRef.current.scrollTop += scrollAmount;
      
      autoScrollIntervalRef.current = requestAnimationFrame(scroll);
    };
    
    autoScrollIntervalRef.current = requestAnimationFrame(scroll);
  };

  const handleTouchStart = (e: React.TouchEvent, data: IndexOrderData) => {
    e.preventDefault(); // 텍스트 선택 방지
    e.stopPropagation();
    touchStartY.current = e.touches[0].clientY;
    pendingDragData.current = data;
    setIsDragging(false);
    
    // 기존 타이머가 있으면 정리
    if (dragStartTimer.current) {
      clearTimeout(dragStartTimer.current);
    }
    
    // DRAG_DELAY 후 드래그 모드 진입
    dragStartTimer.current = setTimeout(() => {
      if (pendingDragData.current) {
        setGrabbedData(pendingDragData.current);
        setIsDragging(true);
      }
      dragStartTimer.current = null;
    }, DRAG_DELAY);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    e.preventDefault(); // pull-to-refresh 방지
    
    // 아직 드래그 모드가 아니면 스크롤 허용
    if (!isDragging && !grabbedData) {
      return;
    }
    
    if (!grabbedData) return;
    
    const touchY = e.touches[0].clientY;
    const container = e.currentTarget as HTMLElement;
    const containerRect = container.getBoundingClientRect();
    
    // Auto-scroll logic
    if (contentContainerRef.current) {
      const scrollThreshold = 50; // 경계로부터 50px 이내에서 자동 스크롤 시작
      const distanceFromTop = touchY - containerRect.top;
      const distanceFromBottom = containerRect.bottom - touchY;
      
      if (distanceFromTop < scrollThreshold && contentContainerRef.current.scrollTop > 0) {
        startAutoScroll('up');
      } else if (distanceFromBottom < scrollThreshold && 
        contentContainerRef.current.scrollTop < contentContainerRef.current.scrollHeight - contentContainerRef.current.clientHeight) {
        startAutoScroll('down');
      } else {
        stopAutoScroll();
      }
    }
    
    // Find which drop space the touch is over
    let targetIndex = orderedDataList.length;
    for (let i = 0; i < cardRefs.current.length; i++) {
      const cardRef = cardRefs.current[i];
      if (cardRef) {
        const cardRect = cardRef.getBoundingClientRect();
        const cardCenterY = cardRect.top + cardRect.height / 2;
        
        if (touchY < cardCenterY) {
          targetIndex = i;
          break;
        }
      }
    }
    
    setDragOverIndex(targetIndex);
  };

  const handleTouchEnd = () => {
    stopAutoScroll();
    
    // 타이머 정리
    if (dragStartTimer.current) {
      clearTimeout(dragStartTimer.current);
      dragStartTimer.current = null;
    }
    
    // 드래그 모드가 아니었으면 (스크롤만 했으면) 아무것도 하지 않음
    if (!isDragging || !grabbedData) {
      setGrabbedData(null);
      setDragOverIndex(null);
      pendingDragData.current = null;
      setIsDragging(false);
      return;
    }
    
    if (dragOverIndex === null) {
      setGrabbedData(null);
      setDragOverIndex(null);
      pendingDragData.current = null;
      setIsDragging(false);
      return;
    }

    const newOrderedList = [...orderedDataList];
    const grabbedIndex = grabbedData.index;
    newOrderedList.splice(grabbedIndex, 1);
    newOrderedList.splice(dragOverIndex > grabbedIndex ? dragOverIndex - 1 : dragOverIndex, 0, grabbedData);

    // Update indices for all items
    const updatedList = newOrderedList.map((item, idx) => ({
      ...item,
      index: idx
    }));

    setOrderedDataList(updatedList);
    setGrabbedData(null);
    setDragOverIndex(null);
    pendingDragData.current = null;
    setIsDragging(false);
  };

  const handleDrop = (index: number) => {
    if (!grabbedData) return;

    const newOrderedList = [...orderedDataList];

    const grabbedIndex = grabbedData.index;
    newOrderedList.splice(grabbedIndex, 1);

    newOrderedList.splice(index > grabbedIndex ? index - 1 : index, 0, grabbedData);

    // Update indices for all items
    const updatedList = newOrderedList.map((item, idx) => ({
      ...item,
      index: idx
    }));

    setOrderedDataList(updatedList);
    setGrabbedData(null);
    setDragOverIndex(null);
  };

  const handleSubmit = async () => {
    const reorderReqList: ReorderReq[] = orderedDataList.map((each) => ({
      index: each.index,
      id: each.id
    }));

    switch (standardModal?.title) {
      case "Project":
        const updateProjectReorderListReq: UpdateReorderListReq = {
          id: "",
          reorderReqList: reorderReqList
        };
        reorderProject(updateProjectReorderListReq);
        break;
      case "Info":
        if (!project) return;
        const updateProjectInfoReorderListReq: UpdateReorderListReq = {
          id: project.id,
          reorderReqList: reorderReqList
        };
        reorderProjectInfo(updateProjectInfoReorderListReq);
        break;
      case "Element":
        if (!project) return;
        const updateProjectElementReorderListReq: UpdateReorderListReq = {
          id: project.id,
          reorderReqList: reorderReqList
        };
        reorderProjectElement(updateProjectElementReorderListReq);
        break;
      case "Carousel":
        if (!standardModal.value) return;
        reorderCarouselItems(
          standardModal.value,
          orderedDataList.map((item) => item.id),
        );
        break;
      case "Text":
        if (!activeText) return;
        reorderTextBlock({
          id: activeText.id,
          reorderReqList: reorderReqList
        });
        break;
      case "Detail Cut":
        if (!activeWork) return;
        reorderWorkDetail({
          id: activeWork.id,
          reorderReqList: reorderReqList
        });
        break;
      case "Career":
        if (!standardModal.value) return;

        const careerMaxIndex = reorderReqList.length - 1;
        const updateCareerReorderListReq: UpdateReorderListReq = {
          id: standardModal.value,
          reorderReqList: reorderReqList.map((req) => ({
            ...req,
            index: careerMaxIndex - req.index,
          })),
        };
        reorderCareer(updateCareerReorderListReq);
        break;
      case "Career Section": {
        const reorderedActiveTypes = orderedDataList.map(
          (item) => item.id as CareerType,
        );
        const didUpdate = await updateCareerSectionOrder({
          careerSectionOrder: mergeActiveCareerSectionOrder(
            aboutPageSetting?.careerSectionOrder,
            reorderedActiveTypes,
          ),
        });
        if (!didUpdate) return;
        break;
      }
      case "Group Member":
        reorderGroupMembers({
          id: "",
          reorderReqList,
        });
        break;
    }
    clearModal(400);
  };

  const handleClose = () => {
    clearModal(400);
  }

  const isIndexingBlocked =
    (standardModal?.title === 'Info' && !(canShowProjectDetail && canShowInfoList)) ||
    (standardModal?.title === 'Element' && !(canShowProjectDetail && canShowElementList)) ||
    (standardModal?.title === 'Project' && !canShowProjectList) ||
    (standardModal?.title === 'Career' && !canShowCareerList) ||
    (standardModal?.title === 'Career Section' &&
      !(canShowCareerList && canShowAboutPageSetting)) ||
    (standardModal?.title === 'Group Member' && !canShowGroupMemberList);

  if (isIndexingBlocked) return null;

  return (
    <IndexingComp>
      <TitleWrapper>
        <TitleContainer>
          <Title>{getModalMessage('REORDER_TITLE', { title: standardModal?.title || '' })}</Title>
          {standardModal?.title === "Career" &&
          <SubTitle>{getCareerTypeTitle(standardModal?.value as CareerType, language)}</SubTitle>
          }
        </TitleContainer>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={handleClose}
          aria-label="Close"
        />
      </TitleWrapper>
      {orderedDataList.length > 0 ? (
        <ContentContainer
          ref={contentContainerRef}
          $isDragging={isDragging}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {orderedDataList.map((each, index) => (
            <React.Fragment key={each.id}>
              <DropSpace
                $isActive={dragOverIndex === index}
              />
              <CardWrapper
                ref={(el) => {
                  cardRefs.current[index] = el;
                }}
                $isDragging={isDragging}
                onTouchStart={(e) => handleTouchStart(e, each)}
                onTouchEnd={handleTouchEnd}
              >
                <IndexCardMobile
                  data={each}
                  isDragging={grabbedData !== null && grabbedData.id === each.id}
                  onDragStart={() => {}}
                  onDragEnd={() => {}}
                />
              </CardWrapper>
            </React.Fragment>
          ))}
          <DropSpace
            $isActive={dragOverIndex === orderedDataList.length}
          />
          <DropSpaceLast />
        </ContentContainer>
      ) : (
        <NoContentContainer>
          {getPageMessage('NO_ITEMS_TO_REORDER')}
        </NoContentContainer>
      )}
      <HeadlessBtn
        value={getBtnName('CHANGE')}
        handleClick={handleSubmit}
        StyledBtn={SubmitButton}
      />
    </IndexingComp>
  );
};

const IndexingComp = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: ${({ theme }) => theme.colors.color_Gray_01};
`;

const Title = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;
const SubTitle = styled.h3`
  ${({ theme }) => theme.typography.Body_02_2};
`;


const ContentContainer = styled.div<{ $isDragging: boolean }>`
  width: 100%;
  height: 100%;
  max-height: 60vh;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  touch-action: ${({ $isDragging }) => $isDragging ? 'none' : 'pan-y'};
  overscroll-behavior-y: contain;
  
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  position: relative;
`

const CardWrapper = styled.div<{ $isDragging: boolean }>`
  width: 100%;
  touch-action: ${({ $isDragging }) => $isDragging ? 'none' : 'pan-y'};
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
`

const NoContentContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.Body_04};
`

const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

const DropSpace = styled.div<{ $isActive?: boolean }>`
  width: 100%;
  height: ${({ $isActive }) => $isActive ? '60px' : '8px'};
  min-height: ${({ $isActive }) => $isActive ? '30px' : '8px'};
  margin: 2px 0;
  border-radius: 2px;
  transition: all 0.4s;
  background-color: transparent;
  border: ${({ $isActive, theme }) => $isActive ? `1px dashed ${theme.colors.color_Gray_05}` : 'none'};
`;

const DropSpaceLast = styled.div`
  width: 100%;
  flex: 1;
  min-height: 20px;
`;

export default IndexingMobile;
